var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadge = function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    clipPath: "url(#badge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m30.998 38.135 4.351 16.24a3.9 3.9 0 0 0 1.036 1.777 3.6 3.6 0 0 0 1.76.953c.655.139 1.329.082 1.943-.165a3.4 3.4 0 0 0 1.531-1.233l2.034-2.94 3.231 1.533a3.4 3.4 0 0 0 1.943.301 3.34 3.34 0 0 0 1.766-.83c.497-.448.86-1.04 1.047-1.705.187-.666.189-1.38.007-2.059l-5.936-22.153M27.025 37.608l-4.493 16.766a3.9 3.9 0 0 1-1.036 1.778 3.6 3.6 0 0 1-1.76.953 3.34 3.34 0 0 1-1.943-.166 3.4 3.4 0 0 1-1.53-1.232l-2.034-2.94-3.232 1.533a3.4 3.4 0 0 1-1.942.301 3.34 3.34 0 0 1-1.766-.83 3.6 3.6 0 0 1-1.048-1.705 3.9 3.9 0 0 1-.006-2.059l6.218-23.208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.42 19.412c0 10.358-8.294 18.745-18.511 18.745s-18.51-8.387-18.51-18.745c0-10.36 8.293-18.746 18.51-18.746s18.51 8.387 18.51 18.746Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.518 19.409c0 4.826-3.862 8.727-8.614 8.727s-8.615-3.901-8.615-8.727 3.863-8.727 8.615-8.727 8.614 3.901 8.614 8.727Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "badge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .166h58v58H0z"
  })))));
};
export default SvgBadge;